// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2sHAH","buttons":"Footer_buttons__12GL4"};